import React, {useState} from 'react'

import {StepsProvider} from './context'

interface Props {
    children: React.ReactNode
}

const StepWizard = ({children}: Props) => {
    const [activeStepIndex, setActiveStepIndex] = useState(0)
    const totalSteps = React.Children.toArray(children).filter(Boolean).length

    const goToStep = (step: number) => {
        if (step >= 0 && step < totalSteps) {
            setActiveStepIndex(step)
        }
    }

    const navigate = {
        next: () => goToStep(activeStepIndex + 1),
        prev: () => goToStep(activeStepIndex - 1),
        goToStep,
    }

    return (
        <StepsProvider
            activeStepIndex={activeStepIndex}
            navigate={navigate}
            totalSteps={totalSteps}
        >
            {React.Children.toArray(children).filter(Boolean)[activeStepIndex]}
        </StepsProvider>
    )
}

export default StepWizard
